import Button from '@/features/ui/buttons/components/Button'
import { FC, memo } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet } from 'react-native'

interface ConfirmButtonProps {
    disabled?: boolean
    loading?: boolean
    onConfirm: () => void
    label?: string
    testID?: string
}

const ConfirmButton: FC<ConfirmButtonProps> = ({ disabled, loading, onConfirm, label, testID }) => {
    const { t } = useTranslation()

    const text = (label || t('actions.confirm')) + (loading ? '...' : '')

    return (
        <Button
            disabled={disabled || loading}
            color="secondary"
            onPress={onConfirm}
            textStyle={styles.buttonText}
            style={styles.button}
            testID={testID}
        >
            {text}
        </Button>
    )
}

const styles = StyleSheet.create({
    button: {
        flexGrow: 1,
        justifyContent: 'center',
    },
    buttonText: {
        textTransform: 'uppercase',
    },
})

export default memo(ConfirmButton)
